import { render, staticRenderFns } from "./SignUpFinished.vue?vue&type=template&id=88b0f338&"
import script from "./SignUpFinished.vue?vue&type=script&lang=js&"
export * from "./SignUpFinished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports